/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsLogEntry,
    MelcoModelsLogEntryFromJSON,
    MelcoModelsLogEntryFromJSONTyped,
    MelcoModelsLogEntryToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsLogEntry
 */
export interface MelcoModelsGenericList1MelcoModelsLogEntry {
    /**
     * 
     * @type {Array<MelcoModelsLogEntry>}
     * @memberof MelcoModelsGenericList1MelcoModelsLogEntry
     */
    list: Array<MelcoModelsLogEntry>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsLogEntry
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsLogEntry
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsLogEntryFromJSON(json: any): MelcoModelsGenericList1MelcoModelsLogEntry {
    return MelcoModelsGenericList1MelcoModelsLogEntryFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsLogEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsLogEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsLogEntryFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsLogEntryToJSON(value?: MelcoModelsGenericList1MelcoModelsLogEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsLogEntryToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


